<template>
<div class="show-editable-row w-full h-7 flex items-center px-3">
  <div
    class="
      font-bold neutral-800
      flex items-center
      select-none
    "
  >
    <input
      type="checkbox"
      name="showEditableObjects-checkbox"
      id="showEditableObjects-checkbox"
      v-model="isShowEditableObjects"
      class="mr-2"
    />
    <label for="showEditableObjects-checkbox">
      Show Editable Objects
    </label>
  </div>
</div>
</template>

<script lang="ts" setup>
import useSlide from '@/views/MediaEditorView/SlideEditor/composables/slide';
const { isShowEditableObjects } = useSlide();

</script>

<style lang="scss" scoped>
.show-editable-row {
  background: var(--bui-ter-input-fill, rgba(0, 0, 0, 0.04));
  color: var(--bui-tbl-row-text, #2a2a30);
  border-bottom: 1px solid var(--bui-tbl-line, #ffd9e6);

  input[type='checkbox'] {
    accent-color: var(--bui-chk-checked-fill, #de3da9);
  }
}
</style>